module.exports = __webpack_public_path__ + "static/img/logo2.e0b80027.png";